/* Actiepagina: de aftelling en de meting van de hoofdknop.

   Twee kleine dingen, en verder niets. De pagina zelf is server-side
   gerenderd; zonder dit bestand blijft alles staan en werkt de knop.
   De looptijdregel is de terugval van de aftelling, dus wie geen
   JavaScript heeft ziet nog steeds hoe lang de actie loopt. */
(function () {
  'use strict';

  var aftel = document.querySelector('[data-solza-actie-aftel]');
  if (aftel) {
    var eind = Date.parse((aftel.dataset.eind || '').replace(' ', 'T'));
    if (!isNaN(eind)) {
      var tik = function () {
        var over = eind - Date.now();
        if (over <= 0) {
          // Afgelopen. De looptijdregel terugzetten heeft geen zin, dus
          // de aftelling verdwijnt en de kop blijft staan; het uitzetten
          // van de actie zelf is een keuze in de editor.
          aftel.hidden = true;
          return;
        }
        var min = Math.floor(over / 60000);
        var dagen = Math.floor(min / 1440);
        var uren = Math.floor((min % 1440) / 60);
        var minuten = min % 60;
        var stukken = [];
        if (dagen) stukken.push(dagen + (dagen === 1 ? ' dag' : ' dagen'));
        if (dagen || uren) stukken.push(uren + ' uur');
        stukken.push(minuten + ' min');
        aftel.textContent = 'nog ' + stukken.join(' ');
        setTimeout(tik, 30000);
      };
      tik();
    }
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-solza-actie-knop]');
    if (!knop || !window.dataLayer) return;
    window.dataLayer.push({
      event: 'actiepagina_cta_click',
      pageType: 'Page',
      actie: knop.dataset.actie || '',
      label: (knop.textContent || '').trim()
    });
  });
})();
